import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { shockwave_contents_root_key } from "./selectShockwaveContents";

/** Builder (admin) list: every row of the base table, whatever its Public flag. */
async function getShockwaveContentsForBuilder() {
    const { data } = await supabaseClient.from("shockwave_contents").select("*").throwOnError();
    return data ?? [];
}

export const shockwave_contents_builder_key = [...shockwave_contents_root_key, "builder"];

export const shockwaveContentsBuilderQueryOptions = () => {
    return queryOptions({
        queryKey: shockwave_contents_builder_key,
        queryFn: async () => getShockwaveContentsForBuilder(),
    });
};

export function useShockwaveContentsBuilderQuery() {
    return useQuery(shockwaveContentsBuilderQueryOptions());
}
